/**
 * Gemi uygulamasının gemi sunucusuna bildirdiği yetenekler (ADR 0169 §3): yeni masaüstü her
 * istekte gönderir; gemi sunucusu yanıtı buna göre biçimler. Sürüm numarasına bağlanmaz (derleme
 * sürümü geliştirmede bilinmez). Değer virgülle ayrılmış yetenek adlarıdır.
 */
export const CLIENT_FEATURES_HEADER = 'x-felix-client-features';

/** Ekran satın alma fiyatını gemide gizler: gemi sunucusu fiyat alanlarını çıkarabilir. */
export const SHIP_PRICES_HIDDEN = 'ship-prices-hidden';

/** Bu masaüstünün bildirdiği yetenekler (başlık değeri). */
export const CLIENT_FEATURES = [SHIP_PRICES_HIDDEN].join(',');

/** Başlık değerinde yetenek var mı; başlık yoksa ya da biçimsizse yok (eski masaüstü). */
export function clientHasFeature(
  header: string | readonly string[] | undefined,
  feature: string,
): boolean {
  if (header === undefined) return false;
  const values = typeof header === 'string' ? [header] : header;
  return values.some((value) =>
    value
      .split(',')
      .map((token) => token.trim().toLowerCase())
      .includes(feature),
  );
}
